import { apiFetch } from '../../lib/api';

/**
 * Maintenance triggers — call api-node /api/admin/*-trigger endpoints directly
 * (replaces web features/admin/api/vehicleCleanupApi + features/cars/api/countdownApi,
 * which proxied through Next.js routes to the Python backend).
 */

export interface MaintenanceTriggerResponse {
  success: boolean;
  message: string;
  task_id?: string | null;
  statistics?: Record<string, unknown> | null;
}

export function triggerCountdownUpdate(
  limit: number,
  updateAll: boolean,
): Promise<MaintenanceTriggerResponse> {
  return apiFetch('admin/countdown-update/trigger', {
    method: 'POST',
    body: { limit, update_all: updateAll },
  });
}

export function triggerVehicleCleanup(): Promise<MaintenanceTriggerResponse> {
  return apiFetch('admin/vehicle-cleanup/trigger', { method: 'POST', body: {} });
}
